import axios from "./configs/axiosConfig";

// key matches anywhere in the plan code; "" matches every plan. active: true limits it to active
// plans -- how TblProductsSearch loads the whole catalog once (#418).
export const getTblProductsSearch = async (key, { active = false } = {}) => {
  const url = `tblproducts/search?key=${encodeURIComponent(key ?? "")}${active ? "&active=1" : ""}`;
  return await axios.get(url);
};
